import { Stack, StackProps } from '@optimus-web/core';
import Menu, { MenuProps } from './Menu';

export interface MenuContainerProps extends MenuProps, React.PropsWithChildren<{}> {
    header?: React.ReactNode;
    headerSpacing?: StackProps['spacing'];
}

const MenuContainer = ({ header, headerSpacing, children, ...other }: MenuContainerProps) => (
    <Stack spacing={headerSpacing} vertical>
        {header}
        <Stack vertical>
            <Menu {...other} />
            {children}
        </Stack>
    </Stack>
);

export default MenuContainer;
